import { REDUX_LOCAL_KEY } from '../../../../redux/constants/local-key'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'

function updateLocalIsDownloadedWorkoutAction (params) {
  return updateWorkoutAction({
    type: params.value
      ? WORKOUTS_ACTION.UPDATE_LOCAL_IS_DOWNLOADED
      : WORKOUTS_ACTION.DELETE_LOCAL_IS_DOWNLOADED,
    payload: {
      key: REDUX_LOCAL_KEY.IS_DOWNLOADED,
      value: params.value,
      workout: params.workout
    }
  })
}

export default updateLocalIsDownloadedWorkoutAction
